import { render, staticRenderFns } from "./KardexMedicamentos.vue?vue&type=template&id=942efd84&"
import script from "./KardexMedicamentos.vue?vue&type=script&lang=js&"
export * from "./KardexMedicamentos.vue?vue&type=script&lang=js&"
import style0 from "./KardexMedicamentos.vue?vue&type=style&index=0&id=942efd84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports